import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import './Terms.css';

export function Terms() {
  const navigate = useNavigate();

  return (
    <div className="terms-page">
      <div className="terms-container">
        <button onClick={() => navigate('/')} className="back-link">
          <ArrowLeft size={18} />
          Volver al inicio
        </button>
        
        <div className="terms-content">
          <h1>Términos del Servicio</h1>
          <p className="version">Versión 1.0 – Fase BETA | Última actualización: 17 de marzo de 2026</p>
          
          <div className="terms-scroll-area">
            <section>
              <p>Al <strong>iniciar sesión con tu cuenta de Discord</strong> y utilizar cualquier servicio de <strong>Voltary</strong> (en adelante "la Plataforma", "el Servicio" o "nosotros"), aceptas estos Términos y Condiciones en su totalidad.</p>
              <p><strong>El registro es OBLIGATORIO y EXCLUSIVO mediante login con Discord (OAuth).</strong> Si no estás de acuerdo con estos términos, no debes iniciar sesión ni utilizar el Servicio.</p>
            </section>

            <section>
              <h3>1. Definiciones</h3>
              <ul>
                <li><strong>Usuario</strong>: Persona física o jurídica que inicia sesión con Discord y utiliza el Servicio.</li>
                <li><strong>Servidor</strong>: Instancia de juego alojada en nuestros servidores.</li>
                <li><strong>Plan</strong>: Paquete de recursos contratado.</li>
              </ul>
            </section>

            <section>
              <h3>2. Aceptación de los Términos</h3>
              <p>Al iniciar sesión con Discord aceptas estos términos y cualquier modificación futura. Podemos actualizar los términos en cualquier momento; el uso continuado implica la aceptación.</p>
            </section>

            <section>
              <h3>3. Registro y seguridad</h3>
              <p>El registro es exclusivo mediante Discord. Al autorizar el acceso, nos otorgas permiso para obtener información básica de tu perfil. Eres el único responsable de la seguridad de tu cuenta de Discord.</p>
            </section>

            <section>
              <h3>4. Fase BETA</h3>
              <p>El servicio es experimental. No garantizamos uptime del 100%. Pueden ocurrir caídas, reinicios o pérdida de datos. EL OPERADOR NO SE HACE RESPONSABLE POR NINGUNA PÉRDIDA DE DATOS O PERJUICIO.</p>
            </section>

            <section>
              <h3>5. Backups</h3>
              <p>Tú eres el único responsable de realizar backups de tus servidores.</p>
            </section>

            <section>
              <h3>6. Pagos y Reembolsos</h3>
              <p>Todos los pagos son manuales. <strong>POLÍTICA DE CERO REEMBOLSOS</strong>: No ofrecemos reembolsos bajo ninguna circunstancia debido a la fase BETA y facturación manual.</p>
            </section>

            <section>
              <h3>7. Uso aceptable</h3>
              <p>Prohibido el uso para actividades ilegales, DDoS, minería o eludir límites técnicos. Violaciones resultan en suspensión permanente sin reembolso.</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
